export default "__VITE_ASSET__Bx7Qee68__"